// **  Initial State
const initialState = {

}

export const meetingReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}
